module.exports = __webpack_public_path__ + "static/media/034.bfb120b7.png";